module.exports = __webpack_public_path__ + "static/media/cart.3ea8cbea.svg";